import { useCountries } from "./countries"
import { useTabs } from "./tabs"

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLDivElement>('[data-tabs')?.forEach(tabs => {
    useTabs(tabs)
  })

  document.querySelectorAll<HTMLInputElement>('[data-select-country]')?.forEach(selectCountry => {
    useCountries(selectCountry)
  })
})